import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'queries';

export interface ReadPropertySpyListParamsModel {
    pagination?: {
        page: number,
        pageSize: number
    }
}

export interface ReadPropertySpyByIdModel {
    propertySpyId: number,
}


export interface StartSpyHostServiceParamsModel {
    hostServiceId: number,
    marketSpyId: number
}

export interface SetChangesViewedParamsModel {
    hostServiceId: number,
}

export const propertySpyApi = createApi({
    reducerPath: 'propertySpyApi',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['PropertySpy'],
    endpoints: (builder) => ({
        readPropertySpyList: builder
            .query({
                query: (params?: ReadPropertySpyListParamsModel) => {
                    let url = `/propspies`;
                    const additionalParams: any[] = [];

                    if (params?.pagination) {
                        const skip: number = params.pagination.page * params.pagination.pageSize;
                        const take: number = params.pagination.pageSize;

                        additionalParams.push({
                            name: 'skip',
                            value: skip
                        });

                        additionalParams.push({
                            name: 'take',
                            value: take
                        });
                    }

                    if (additionalParams.length > 0) {
                        const paramsString: string = additionalParams
                            .map((additionalParam) => {
                                return `${additionalParam.name}=${additionalParam.value}`;
                            })
                            .join('&');

                        url = `${url}?${paramsString}`
                    }

                    return url;
                },
                providesTags: (result) => result
                    ? [
                        ...result.list.map(({ id }: any) => ({ type: 'PropertySpy', id })),
                        { type: 'PropertySpy', id: 'LIST' },
                    ]
                    : [
                        { type: 'PropertySpy', id: 'LIST' }
                    ],
            }),
        readPropertySpyById: builder
            .query({
                query: (params: ReadPropertySpyByIdModel) => {
                    let url = `/propspies/${params.propertySpyId}`;

                    return url;
                },
            }),
        setChangesViewed: builder
            .mutation({
                query: ({ hostServiceId }: SetChangesViewedParamsModel) => ({
                    url: `/propspies/${hostServiceId}/setviewed`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                ]
            }),
        startSpyHostService: builder
            .mutation({
                query: ({ hostServiceId, marketSpyId }: StartSpyHostServiceParamsModel) => ({
                    url: `/hostservices/${hostServiceId}/startspy?monitorId=${marketSpyId}`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                ]
            }),
        stopSpyHostService: builder
            .mutation({
                query: ({ hostServiceId, marketSpyId }: StartSpyHostServiceParamsModel) => ({
                    url: `/hostservices/${hostServiceId}/stopspy?monitorId=${marketSpyId}`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                ]
            }),
    }),
});

export const {
    useReadPropertySpyListQuery,
    useReadPropertySpyByIdQuery,
    useLazyReadPropertySpyByIdQuery,
    useStartSpyHostServiceMutation,
    useStopSpyHostServiceMutation,
    useSetChangesViewedMutation,
} = propertySpyApi
